"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var columnSetFactory_1 = require("./columnSetFactory");
var FilterLevelCalculator_1 = require("./datalayer/FilterLevelCalculator");
var configuration_1 = require("./configuration");
var Export = (function () {
    function Export() {
    }
    Export.cloneColumnTypes = function (columnTypes) {
        return _.mapValues(columnTypes, function (columnType) { return _.omit(columnType, ["key", "editor"]); });
    };
    Export.exportColumnSet = function (exportColumnTypes, columnSet) {
        return {
            name: columnSet.name,
            columns: columnSet.columns
                .filter(function (column) { return column.dataPath !== undefined; })
                .filter(function (column) {
                return (_.get(column, "settings.excludeFromExport") !== true);
            })
                .map(function (column) { return exportColumnTypes[column.key]; })
        };
    };
    Export.exportColumnSets = function (columnSets, planName) {
        var columnTypes = Export.cloneColumnTypes(columnSetFactory_1.ColumnSetFactory.getColumnTypes());
        columnTypes["MEDIUM_NAME"].caption = planName;
        columnTypes["MEDIUM_NAME_STROER"].caption = planName;
        var result = columnSets.map(Export.exportColumnSet.bind(undefined, columnTypes));
        return result;
    };
    Export.exportRow = function (columns, limitValue) {
        return function (row) {
            var result = { rawSample: _.get(row, "rawSample") };
            columns.forEach(function (column) {
                var dataPath = column.dataPath;
                var textOnEmpty = _.get(column, "settings.textOnEmpty");
                switch (column.key) {
                    case "MEDIUM_PERIOD":
                    case "POSTER_PERIOD":
                        var displayMap_1 = column.editor.config.display;
                        var list = Object.keys(displayMap_1).map(function (key) { return ({ value: key, caption: displayMap_1[key] }); });
                        var currentValue_1 = _.get(row, dataPath);
                        _.set(result, dataPath, {
                            _list: list,
                            _index: _.findIndex(list, function (item) { return item.value === currentValue_1; })
                        });
                        break;
                    case "TARGETING":
                        _.set(result, dataPath, _.cloneDeep(_.get(row, dataPath + ".shortDescription")));
                        break;
                    case "AD_FORMAT":
                        var adFormat = (_.get(row, dataPath));
                        if (!adFormat) {
                            break;
                        }
                        if (adFormat.currentIndex !== -1) {
                            _.set(result, dataPath, _.cloneDeep(adFormat));
                        }
                        else {
                            _.set(result, dataPath, _.cloneDeep(adFormat.notFoundText));
                        }
                        break;
                    case "MEDIUM_PERIOD_DIALOG":
                        var actualDataPath = dataPath + ".content.ownTitle";
                        var periodValue = _.get(row, actualDataPath) || textOnEmpty;
                        _.set(result, dataPath, _.cloneDeep(periodValue));
                        break;
                    default:
                        var value = _.get(row, dataPath) || textOnEmpty;
                        _.set(result, dataPath, _.cloneDeep(value));
                }
                Export.filterRow(result, column, limitValue);
            });
            return result;
        };
    };
    Export.exportRows = function (columnSets, rows, limitValue) {
        var allColumns = _.uniq(columnSets.map(function (columnSet) { return columnSet.columns; })
            .reduce(function (previous, current) { return previous.concat(current); })
            .filter(function (column) { return column.dataPath !== undefined; }), function (column) { return column.key; });
        var allColumnsFiltered = allColumns.filter(function (column) {
            return (_.get(column, "settings.excludeFromExport") !== true);
        });
        return rows.map(Export.exportRow(allColumnsFiltered, limitValue));
    };
    Export.filterRow = function (row, column, limitValue) {
        var dataPath = column.dataPath;
        var minLevel = _.get(column, "settings.level");
        if (minLevel) {
            var thisLevel = FilterLevelCalculator_1.FilterLevelCalculator.calculateLevel(_.get(row, "rawSample"), limitValue);
            if (thisLevel < minLevel) {
                _.set(row, dataPath, configuration_1.PlanConfiguration.limitationText);
            }
        }
    };
    return Export;
}());
exports.Export = Export;
//# sourceMappingURL=export.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/export.js
// module id = 73
// module chunks = 0